module.exports = __webpack_public_path__ + "img/lunbotu.62d2122c.png";